/* 🤖 this file was generated by svg-to-ts */
export const matIconTurnRight: {
  name: 'turn-right';
  data: string;
} = {
  name: 'turn-right',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m17.17 11-1.59 1.59L17 14l4-4-4-4-1.41 1.41L17.17 9H9c-1.1 0-2 .9-2 2v9h2v-9h8.17z"/></svg>`
};
